import { InjectionToken } from '@angular/core';

export const formErrorMessages = {
  required: () => 'This field is required.',
  trim: () => 'Empty field is not allowed.',
  futureDate: () => 'Date is incorrect.',
  minlength: ({ requiredLength }: { requiredLength: number }) => {
    return `Must be at least ${requiredLength} characters long.`;
  },
  maxlength: ({ requiredLength }: { requiredLength: number }) => `Must be maximum ${requiredLength} characters long.`,
  email: () => 'Email format incorrect.',
  password: () => 'Password format incorrect.',
  alpha: () => 'Should contain only alphabets.',
  codeMismatch: () => 'Incorrect confirmation code.',
  emailMismatch: () => "Can't find a user with provided email.",
  phoneMismatch: () => "Can't find a user with provided phone number.",
  valuesNotEqual: () => 'Passwords not equal.',
  fullNameTrim: () => 'Name cannot start or end with a space.',
  fullNameInvalidChars: () => 'Only letters, numbers, apostrophes, and hyphens are allowed.',
};

export const FORM_ERRORS = new InjectionToken('FORM_ERRORS', {
  providedIn: 'root',
  factory: () => formErrorMessages,
});
